export enum AbandonmentOption {
    Full_Removal = 'Full_Removal',
    Partial_Removal = 'Partial_Removal',
    Leave_in_Place = 'Leave_in_Place',
    Cap_and_Monitor = 'Cap_and_Monitor',
    Removal = 'Removal',
}
